import {useEffect, useRef} from "react";
import {FileFragmentFragment} from "@/graphql/graphql";

export function usePreloadFiles(files: FileFragmentFragment[]) {
  const isCalledRef = useRef(false);
  
  useEffect(() => {
    if (files && files?.length !== 0 && !isCalledRef.current) {
      isCalledRef.current = true;
      //preloading image
      files.forEach((face) => {
        if (face.url)
          fetch(face.url);
      });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
}
